
// -------- Helpers --------
const cssEscape = (v) => (window.CSS && CSS.escape ? CSS.escape(v) : v.replace(/"/g, '\\"')); 

function toggleClearBtn() {
  const hasChecked = document.querySelector('.filter-cb:checked, .mb-filter-cb:checked');
  document.querySelectorAll('blog-filter .cl-btn, blog-filter-mob .cl-btn').forEach(btn => {
    if (hasChecked) {
      btn.classList.remove('hidden');
    } else {
      btn.classList.add('hidden');
    }
  });
}

function syncFilters(value, type) {
  document.querySelectorAll('.filter-cb, .mb-filter-cb').forEach(cb => {
    cb.checked = false;
    cb.removeAttribute('checked');
    cb.classList.remove('checked');
  });

  if (type === 'clear' || !value) {
    toggleClearBtn();
    return;
  }

  const escaped = cssEscape(value);
  document.querySelectorAll(`.filter-cb[value="${escaped}"], .mb-filter-cb[value="${escaped}"]`)
    .forEach(cb => {
      cb.checked = true;
      cb.setAttribute('checked', 'checked');
      cb.classList.add('checked');
    });

  toggleClearBtn();
}

document.addEventListener('change', (event) => {
  const input = event.target.closest('input[type="checkbox"].filter-cb, input[type="checkbox"].mb-filter-cb');
  if (!input) return;

  syncFilters(input.value);

  const label = input.closest('label');
  const link = label && label.querySelector('blog-filter a, blog-filter-mob a');
  if (!link) return;

  const component = link.closest('blog-filter, blog-filter-mob');
  if (component && typeof component.loadContent === 'function') {
    component.loadContent(link);
  }
});

if (!customElements.get('blog-filter')) {
  customElements.define('blog-filter', class extends HTMLElement {
    constructor() {
      super();
      this.content_container = document.querySelector('.blog-posts__container');
      this.addEventListener('click', this.clickEvent.bind(this));
    }

    clickEvent(event) {
      const anchor = event.target.closest('a');
      if (!anchor) return;
      event.preventDefault();

      if (anchor.classList.contains('cl-btn')) {
        syncFilters(null, 'clear');
        anchor.classList.add('hidden');
        this.loadContent(anchor);
        return;
      }

      const label = anchor.closest('label');
      if (label) {
        const relatedInput = label.querySelector('input[type="checkbox"]');
        if (relatedInput) syncFilters(relatedInput.value);
      } else {
        syncFilters(null, 'clear');
      }

      this.loadContent(anchor);
    }

    loadContent(link) {
      const new_url = link.getAttribute('href');
      const section_id = this.getAttribute('section-id');
      const url = `${new_url}?section_id=${section_id}`;

      fetch(url, { credentials: 'same-origin', method: 'GET' })
        .then(r => r.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const ajax_container = html.querySelector('.blog-posts__container');
          if (ajax_container) {
            this.content_container.innerHTML = ajax_container.innerHTML;
            initInfiniteScroll();
          }
          window.history.replaceState({ path: new_url }, "", new_url);
        })
        .catch(console.error);
    }
  });
}

if (!customElements.get('blog-filter-mob')) {
  customElements.define('blog-filter-mob', class extends HTMLElement {
    constructor() {
      super();
      this.content_container = document.querySelector('.blog-posts__container');
      this.addEventListener('click', this.clickEvent.bind(this));
    }

    clickEvent(event) {
      const anchor = event.target.closest('a');
      if (!anchor) return;
      event.preventDefault();

      if (anchor.classList.contains('cl-btn')) {
        syncFilters(null, 'clear');
        anchor.classList.add('hidden');
        this.loadContent(anchor);
        return;
      }

      const label = anchor.closest('label');
      if (label) {
        const relatedInput = label.querySelector('input[type="checkbox"]');
        if (relatedInput) syncFilters(relatedInput.value);
      } else {
        syncFilters(null, 'clear');
      }

      this.loadContent(anchor);
    }

    loadContent(link) {
      const new_url = link.getAttribute('href');
      const section_id = this.getAttribute('section-id');
      const url = `${new_url}?section_id=${section_id}`;

      fetch(url, { credentials: 'same-origin', method: 'GET' })
        .then(r => r.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const ajax_container = html.querySelector('.blog-posts__container');
          if (ajax_container) {
            this.content_container.innerHTML = ajax_container.innerHTML;
            initInfiniteScroll();
          }
          window.history.replaceState({ path: new_url }, "", new_url);
        })
        .catch(console.error);
    }
  });
}
// function initInfiniteScroll() {
//   const container = document.querySelector(".blog-posts__container .blog-posts");
//   const loader = document.getElementById("infinite-scroll-loader");
//   const totalPagesEl = document.querySelector("[data-total-pages]");
//   if (!container || !loader || !totalPagesEl) return;

//   let currentPage = 1;
//   let totalPages = parseInt(totalPagesEl.dataset.totalPages);
//   let isLoading = false;

//   // Build the next page URL while preserving filters
//   function buildNextPageUrl(page) {
//     const url = new URL(window.location.href);
//     url.searchParams.set("page", page); // Replace or add page param
//     return url.toString();
//   }

//   async function loadNextPage() {
//     if (isLoading || currentPage >= totalPages) return;
//     isLoading = true;
//     loader.style.display = "block";

//     currentPage++;
//     const nextPageUrl = buildNextPageUrl(currentPage);

//     try {
//       const response = await fetch(nextPageUrl);
//       const text = await response.text();
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(text, "text/html");
//       const newPosts = doc.querySelectorAll(".blog-posts .blog-post-card");

//       // Append only posts that don't already exist (avoid duplicates)
//       newPosts.forEach(post => {
//         const id = post.dataset.postId;
//         if (!container.querySelector(`[data-post-id="${id}"]`)) {
//           container.appendChild(post);
//         }
//       });

//       const newTotal = doc.querySelector("[data-total-pages]");
//       if (newTotal) totalPages = parseInt(newTotal.dataset.totalPages);
//     } catch (err) {
//       console.error("Infinite scroll error:", err);
//     }

//     loader.style.display = "none";
//     isLoading = false;
//   }

//   // Reset scroll handler to avoid duplicates
//   window.removeEventListener("scroll", window._infiniteScrollHandler);
//   window._infiniteScrollHandler = () => {
//     if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 300) {
//       loadNextPage();
//     }
//   };
//   window.addEventListener("scroll", window._infiniteScrollHandler);
// }

function initInfiniteScroll() {
  const container = document.querySelector(".blog-posts__container .blog-posts");
  const loader = document.getElementById("infinite-scroll-loader");
  const totalPagesEl = document.querySelector("[data-total-pages]");
  if (!container || !loader || !totalPagesEl) return;

  let currentPage = 1;
  let totalPages = parseInt(totalPagesEl.dataset.totalPages);
  let isLoading = false;
  const isMobile = window.innerWidth <= 768;

  // Hide extra posts on mobile initially
  if (isMobile) {
    const posts = container.querySelectorAll(".blog-post-card");
    posts.forEach((post, index) => {
      if (index >= 3) post.style.display = "none";
    });
  }

  function buildNextPageUrl(page) {
    const url = new URL(window.location.href);
    url.searchParams.set("page", page);
    return url.toString();
  }

  async function loadNextPage() {
    if (isLoading || currentPage >= totalPages) {
      loader.style.display = "none"; // hide loader if no more pages
      return;
    }

    isLoading = true;
    loader.style.display = "block";

    currentPage++;
    const nextPageUrl = buildNextPageUrl(currentPage);

    try {
      const response = await fetch(nextPageUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      const newPosts = doc.querySelectorAll(".blog-posts .blog-post-card");

      newPosts.forEach(post => {
        const id = post.dataset.postId;
        if (!container.querySelector(`[data-post-id="${id}"]`)) {
          container.appendChild(post);
          if (isMobile) post.style.display = "none"; // hide new posts on mobile initially
        }
      });

      const newTotal = doc.querySelector("[data-total-pages]");
      if (newTotal) totalPages = parseInt(newTotal.dataset.totalPages);

      // Hide loader if we reached the last page
      if (currentPage >= totalPages) {
        loader.style.display = "none";
      }
    } catch (err) {
      console.error("Infinite scroll error:", err);
      loader.style.display = "none"; // hide loader on error
    }

    isLoading = false;
  }

  function revealHiddenPosts() {
    if (!isMobile) return;

    const hiddenPosts = container.querySelectorAll(".blog-post-card[style*='display: none']");
    if (hiddenPosts.length > 0) {
      loader.style.display = "block"; // show loader

      // Reveal 3 posts with a small delay so loader is visible
      setTimeout(() => {
        for (let i = 0; i < 3 && i < hiddenPosts.length; i++) {
          hiddenPosts[i].style.display = "grid";
        }
        loader.style.display = "none"; // hide loader after revealing
      }, 300); // adjust delay if needed
    } else {
      loadNextPage(); // fetch more posts if none hidden
    }
  }

  // Remove any existing scroll handler to prevent duplicates
  window.removeEventListener("scroll", window._infiniteScrollHandler);
  window._infiniteScrollHandler = () => {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 300) {
      if (isMobile) {
        revealHiddenPosts();
      } else {
        loadNextPage();
      }
    }
  };

  window.addEventListener("scroll", window._infiniteScrollHandler);

  // Hide loader if there's only one page
  if (totalPages <= 1) loader.style.display = "none";
}

// Initialize after page load
document.addEventListener("DOMContentLoaded", initInfiniteScroll);


document.addEventListener("DOMContentLoaded", () => {
  toggleClearBtn();
  initInfiniteScroll();
});


